import ButtonCard from '../ButtonCards/ButtonCard';
import cx from 'classnames';
import styles from '../errorPage.module.scss';
import {
  ContactPhoneIcon,
  ExportIcon,
  QuestionIcon
} from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { replaceTokensInString, normalizeUrl } from '@app/utils';
import useHelpCenterLink from '@app/components/pages/csr-landing/hooks/useHelpCenterLink';
import { useSelector } from 'react-redux';
import useGetCustCareTelephonyInfo from '@app/components/pages/control-center/common/hooks/useGetCustomerTelephonyInfo/useGetCustomerTelephonyInfo';
import endpoints from '@app/constants/endpoints';
import CallUsMessage from './CallUsMessage/CallUsMessage';

function WidgetRow() {
  const { t } = useTranslation();
  const { getHelpCenterFAQURL, getHelpCenterContactSupportURL } =
    useHelpCenterLink();
  const seoURL = useSelector(s => s.dealer.seoURL);
  const catalogId = useSelector(s => s.common.catalogId);
  const langId = useSelector(s => s.common.langId);
  const storeId = useSelector(s => s.common.storeId);
  const helpCenterEnabled = useSelector(
    s => s.featureFlag?.PCCCustomerSupportHelpCenter
  );
  const faqLegacyURL = replaceTokensInString(
    endpoints.FOOTER_LINK_HELP_CENTER,
    seoURL
  );
  const faqURL = helpCenterEnabled ? getHelpCenterFAQURL() : faqLegacyURL;

  const contactSupportLegacyURL = normalizeUrl(
    replaceTokensInString(
      `${seoURL}${endpoints.CONTACT_US_DEALER}`,
      catalogId,
      langId,
      storeId
    )
  );
  const contactSupportURL = helpCenterEnabled
    ? getHelpCenterContactSupportURL()
    : contactSupportLegacyURL;

  const isCatCorp = useSelector(s => s.common.isCatCorp);

  const countryTelephonyInfo = useGetCustCareTelephonyInfo();
  const tollFreeNumber = countryTelephonyInfo?.regionalNumbers?.tollFreeNumber;
  const phoneNumber = countryTelephonyInfo?.regionalNumbers?.phoneNumber;
  const directNumber = countryTelephonyInfo?.regionalNumbers?.direct;

  const phone = useSelector(s => s.store.phone);

  return (
    <div
      className={cx(
        styles['error-page__widgets'],
        'd-flex flex-column flex-md-row'
      )}
    >
      <ButtonCard shouldOpenInNewTab={helpCenterEnabled} link={faqURL}>
        <QuestionIcon
          style={{
            fill: '#FFCC00',
            width: '32px',
            height: '32px',
            alignSelf: 'center'
          }}
        />

        <p
          className={cx(styles['error-page__card-title-link'], 'fw-bold mt-2')}
        >
          {t('HELP_CTR_MNU_FAQ')}
        </p>

        <p className={cx(styles['error-page__card-text'], 'mt-2')}>
          {t('FAQS_DETAILS')}
        </p>
      </ButtonCard>
      <ButtonCard>
        <ContactPhoneIcon
          style={{
            fill: '#FFCC00',
            width: '32px',
            height: '32px',
            alignSelf: 'center'
          }}
        />
        <h5
          className={cx(styles['error-page__card-title-link'], 'fw-bold mt-2')}
        >
          {t('CALL_US')}
        </h5>
        <div className={cx(styles['error-page__card-text'], 'm-2')}>
          <CallUsMessage
            isCatCorp={isCatCorp}
            helpCenterEnabled={isCatCorp || helpCenterEnabled}
            tollFreeNumber={tollFreeNumber}
            phoneNumber={phoneNumber}
            directNumber={directNumber}
            localPhone={phone}
          />
        </div>
      </ButtonCard>
      <ButtonCard
        shouldOpenInNewTab={helpCenterEnabled}
        link={contactSupportURL}
      >
        <ExportIcon
          style={{
            fill: '#FFCC00',
            width: '32px',
            height: '32px',
            alignSelf: 'center'
          }}
        />
        <p
          className={cx(styles['error-page__card-title-link'], 'fw-bold mt-2')}
        >
          {t('SUBMIT_A_FORM')}
        </p>
        <p className={cx(styles['error-page__card-text'], 'm-2')}>
          {t('SUBMIT_A_FORM_DETAILS')}
        </p>
      </ButtonCard>
    </div>
  );
}

export default WidgetRow;
